import { css } from "styled-components";
import { FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius, Padding } from "../../../../../../../../styles/common/mixins/logical.styled.js";
const veciAddRoomStyles = {
    AddRoomButton: ()=>css`
		${Padding({
            x: '0'
        })};
		min-height: auto;
		height: auto;
		text-decoration: underline;
		${BorderRadius({
            all: '0'
        })};
		${FontMixin({
            height: 'base'
        })}
	`
};
export default veciAddRoomStyles;

//# sourceMappingURL=veci.js.map